var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 54,
    viewBox: "0 0 57 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1204_168)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 41.25,
    height: 38.5,
    rx: 7.33333,
    fill: "#ECECEC",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1204_168)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0559 25.2674L23.1689 27.3959L26.1697 25.3257L32.8962 31.962C32.7187 32.02 32.531 32.0493 32.333 32.05H14.0004C13.7584 32.05 13.5274 32.0027 13.3151 31.918L20.0559 25.2674ZM34.1667 19.8136V30.2163C34.1667 30.488 34.1073 30.7454 34.0017 30.9775L27.4083 24.4721L34.1667 19.8136ZM12.1667 19.8719L18.8129 24.4171L12.2833 30.8609C12.2068 30.6546 12.1673 30.4364 12.1667 30.2163V19.8719ZM32.333 15.55C33.345 15.55 34.1667 16.3706 34.1667 17.3837V18.0283L23.1645 25.6128L12.1667 18.091V17.3837C12.1667 16.3717 12.9873 15.55 14.0004 15.55H32.333Z",
    fill: "#2E5C33"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1204_168",
    x: 0.25,
    y: 0.333333,
    width: 55.9167,
    height: 53.1667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.58333,
    dy: 3.66667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1204_168"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1204_168",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1204_168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 17.2857,
    fill: "white",
    transform: "translate(12.1667 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon1);
export default __webpack_public_path__ + "static/media/mail_icon 1.d3c63c09e7d090f0f308685dd4fb141b.svg";
export { ForwardRef as ReactComponent };